// Registry for keeping track of drag-and-drop elements
export function createRegistry() {
  // Registries to track cards and columns
  const cardRegistry = new Map();
  const columnRegistry = new Map();

  // Register a card element
  function registerCard({ taskId, entry }) {
    cardRegistry.set(taskId, entry);
    return () => {
      cardRegistry.delete(taskId);
    };
  }

  // Register a column element
  function registerColumn({ columnId, entry }) {
    columnRegistry.set(columnId, entry);
    return () => {
      columnRegistry.delete(columnId);
    };
  }

  // Get a card by ID
  function getCard(cardId) {
    return cardRegistry.get(cardId);
  }

  // Get a column by ID
  function getColumn(columnId) {
    return columnRegistry.get(columnId);
  }

  return {
    registerCard,
    registerColumn,
    getCard,
    getColumn,
  };
}